<script>

import ImgWithLoading from '@/plugins/EntityFrameWork/Base/ImgWithLoading.vue'
import imageCompression from 'browser-image-compression'
import { colorList } from '@/model/dataLayer/api/Vip/VipCommon'

export default {
  name: 'DisplayInfo',
  components: { ImgWithLoading },
  data: function () {
    return {
      colorList,
      fileStore: null
    }
  },
  props: {
    editMode: {
      default: false
    },
    info: {
      type: Object,
      default: () => {
        return {
          name: '',
          description: '',
          color: '#eeeeee',
          imageUrl: ''
        }
      }
    },
    width: {
      default: '100%'
    }
  },
  watch: {
    fileStore: {
      deep: true,
      immediate: true,
      handler: async function (val) {
        if (val) {
          const options = {
            maxSizeMB: 1,
            useWebWorker: true
          }
          this.$set(this.info, 'imageUrl', await imageCompression(val, options))
        }
      }
    }
  },
  computed: {
    uploadUrl: function () {
      if (typeof this.info.imageUrl === 'string') {
        return this.info.imageUrl
      } else {
        return URL.createObjectURL(this.info.imageUrl)
      }
    }
  },
  methods: {
    startUpload () {
      this.$refs.file.$refs.input.click()
    }
  }
}
</script>

<template>
  <v-card
    :width="width"
    class="pa-4 d-flex flex-column"
    color="#eeeeee"
    elevation="0"
  >
    <div
      v-if="!editMode"
      class="d-flex flex-column align-center"
    >
      <v-card
        class="d-flex justify-center align-center"
        color="#eeeeee"
        flat
        height="160px"
        width="160px"
      >
        <img-with-loading
          v-if="info?.imageUrl"
          :height="'160px'"
          :img-src="uploadUrl"
        />
      </v-card>
    </div>
    <div
      v-else
      class="d-flex flex-column align-center"
    >
      <v-card
        class="d-flex justify-center align-center"
        color="#eeeeee"
        flat
        height="160px"
        width="160px"
        @click="startUpload"
      >
        <img-with-loading
          v-if="info?.imageUrl"
          :height="'160px'"
          :img-src="uploadUrl"
        />
        <v-btn
          absolute
          bottom
          color="primary"
          fab
          style="right: -12px"
          x-small
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card>
      <v-file-input
        ref="file"
        v-model="fileStore"
        accpet="image/*"
        class="mt-2"
        counter
        dense
        hide-details
        outlined
        prepend-icon=""
        prepend-inner-icon="mdi-file"
        show-size
        style="height: 0;opacity: 0"
      />
    </div>
    <v-spacer />
    <div
      v-if="!editMode"
      class="d-flex mt-4"
    >
      <div>
        <div class="text-body-1">
          {{ info?.name }}
        </div>
        <div class="text-caption">
          {{ info?.description }}
        </div>
      </div>
      <v-spacer />
      <v-card
        :color="info?.color"
        class="d-flex align-center justify-center"
        elevation="0"
        height="48px"
        width="48px"
      />
    </div>
    <div
      v-else
      class="d-flex flex-column mt-4"
    >
      <v-text-field
        v-model="info.name"
        :label="$t('name')"
        dense
        outlined
      />
      <v-text-field
        v-model="info.description"
        :label="$t('description')"
        dense
        outlined
      />
      <div>
        <v-item-group
          v-model="info.color"
          mandatory
        >
          <div
            style="display: grid;
        grid-template-columns: repeat(auto-fill,48px);
        grid-gap: 4px;"
          >
            <v-item
              v-for="color in colorList"
              :key="color"
              v-slot="{active,toggle}"
              :value="color"
            >
              <v-card
                :color="color"
                class="d-flex align-center justify-center"
                height="48px"
                width="48px"
                @click="toggle"
              >
                <v-icon v-if="active">
                  mdi-check
                </v-icon>
              </v-card>
            </v-item>
          </div>
        </v-item-group>
      </div>
    </div>
  </v-card>
</template>

<style scoped>

</style>
